import { render, staticRenderFns } from "./Predaj.vue?vue&type=template&id=004633a6&scoped=true&"
import script from "./Predaj.vue?vue&type=script&lang=js&"
export * from "./Predaj.vue?vue&type=script&lang=js&"
import style0 from "./Predaj.vue?vue&type=style&index=0&id=004633a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004633a6",
  null
  
)

export default component.exports